// RGM theme behaviors
// Class names and breakpoint verified against the mockup CSS (css/rgm.css):
//   - mobile nav open state:  .nav.is-open  (CSS: .nav.is-open .nav__links)
//   - mobile dropdown open:   .nav__drop.is-open  (CSS: .nav__drop.is-open > .nav__drop-panel)
//   - reveal-on-scroll:       .reveal -> .is-in  (CSS: .reveal.is-in)
//   - nav drawer breakpoint:  max-width 1300px (desktop nav uses CSS hover above this;
//                              the full bar does not fit below ~1300px)
//   - sticky header:          CSS position:sticky (.nav); JS adds/removes .nav--hidden
//                              and body.nav-hidden for the "on scroll up" auto-hide mode
(function () {
  // Mobile main-nav toggle. The toggle button lives inside .nav and controls #nav-links,
  // but the CSS opens the menu via .nav.is-open, so we toggle the class on the nav element.
  window.toggleNav = function (btn) {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  // Drawer dropdown toggle. On desktop (> 1300px) CSS hover normally handles it,
  // unless the header's "Open dropdowns on" setting is Click, in which case we
  // intercept there too (the CSS hover reveal is suppressed in that mode).
  window.toggleDrop = function (e, trigger) {
    var navEl = document.getElementById('nav');
    var clickMode = navEl && navEl.dataset.openMenu === 'click';
    // 1301px must match the drawer breakpoint in assets/rgm.css.
    if (window.matchMedia('(min-width: 1301px)').matches && !clickMode) return;
    e.preventDefault();
    var drop = trigger.closest('.nav__drop');
    if (drop) {
      var open = drop.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  // Reveal-on-scroll. CSS already neutralizes .reveal under prefers-reduced-motion,
  // so reduced-motion users see content regardless. In the theme editor (design mode)
  // we skip the animation entirely, and we re-init after the editor re-renders a
  // section, because re-rendered .reveal elements would otherwise stay at opacity 0.
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveals(root) {
    var scope = root || document;
    var reveals = scope.querySelectorAll('.reveal:not(.is-in)');
    var designMode = window.Shopify && window.Shopify.designMode;
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  }
  initReveals(document);
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });

  // Sticky header "on scroll up" mode: hide on downward scroll, show on upward.
  // The nav is re-queried on every tick (not cached once at load) so this keeps
  // working if the theme editor re-renders the header section with a new nav element.
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var nav = document.querySelector('.nav[data-sticky="on_scroll_up"]');
    if (!nav) return;
    var y = window.scrollY;
    if (!nav.classList.contains('is-open')) {
      if (y > lastY && y > 120) {
        nav.classList.add('nav--hidden');
        document.body.classList.add('nav-hidden');
      } else {
        nav.classList.remove('nav--hidden');
        document.body.classList.remove('nav-hidden');
      }
    }
    lastY = y;
  }, { passive: true });

  // Anchor-nav scroll-spy: highlight the link whose target section is in view
  var anchorNav = document.querySelector('.anchor-nav');
  if (anchorNav && 'IntersectionObserver' in window) {
    var spyLinks = Array.prototype.slice.call(anchorNav.querySelectorAll('a[href^="#"]'));
    var spyById = {};
    spyLinks.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (target) spyById[id] = a;
    });
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          spyLinks.forEach(function (l) { l.classList.remove('is-active'); });
          var active = spyById[en.target.id];
          if (active) active.classList.add('is-active');
        }
      });
    }, { rootMargin: '-120px 0px -65% 0px', threshold: 0 });
    Object.keys(spyById).forEach(function (id) { spy.observe(document.getElementById(id)); });
  }

  // PDP: variant resolution, quantity stepper, gallery thumbnails, share.
  // Guarded -- only runs on the product template (theme/sections/product.liquid).
  //
  // The product form now lives inside the buy_buttons block and everything
  // outside it is bound with form=, because blocks are reorderable and a form
  // cannot wrap them. The hidden [data-pdp-variant-id] input inside that form is
  // the single source of the chosen variant; the option controls only drive it.
  // With JS off none of this runs and the <noscript> select named `id` submits
  // instead, which is what stops a broken script silently ordering the first
  // variant (Ken QC 2026-09-04, 4.2).
  var pdpSection = document.querySelector('.pdp');
  if (pdpSection) {
    var variantsScript = pdpSection.querySelector('[data-pdp-variants-json]');
    var pdpVariants = [];
    if (variantsScript) {
      try { pdpVariants = JSON.parse(variantsScript.textContent); } catch (e) { pdpVariants = []; }
    }
    var idInput = pdpSection.querySelector('[data-pdp-variant-id]');
    var priceEl = pdpSection.querySelector('[data-pdp-price]');
    var buyBtn = pdpSection.querySelector('[data-pdp-buy]');
    var buyLabel = pdpSection.querySelector('[data-pdp-buy-label]');

    // Money formatting comes off the rendered price so it follows the store's
    // own currency and format instead of a hard-coded dollar sign. Falls back to
    // the plain amount if the initial markup is missing.
    var moneyTemplate = null;
    var initialPriceNode = priceEl && priceEl.querySelector('.pdp-price__num');
    if (initialPriceNode && pdpVariants.length) {
      var initialText = initialPriceNode.textContent.trim();
      var initialVariant = null;
      if (idInput) {
        initialVariant = pdpVariants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
      }
      if (initialVariant) {
        var amount = (initialVariant.price / 100).toFixed(2);
        var idx = initialText.indexOf(amount);
        if (idx !== -1) {
          moneyTemplate = { before: initialText.slice(0, idx), after: initialText.slice(idx + amount.length) };
        }
      }
    }
    function pdpMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyTemplate) return moneyTemplate.before + amount + moneyTemplate.after;
      return amount;
    }

    // Every option control carries data-pdp-option="<index>": a <select>, a group
    // of radios, or a hidden input standing in for an option the picker hides
    // because it has only one value. All three are read the same way, so hiding
    // an option cannot break variant resolution.
    function pdpChosenOptions() {
      var byIndex = [];
      Array.prototype.forEach.call(pdpSection.querySelectorAll('[data-pdp-option]'), function (el) {
        var i = parseInt(el.getAttribute('data-pdp-option'), 10);
        if (isNaN(i)) return;
        if (el.type === 'radio') {
          if (el.checked) byIndex[i] = el.value;
        } else {
          byIndex[i] = el.value;
        }
      });
      return byIndex;
    }

    function pdpFindVariant() {
      var chosen = pdpChosenOptions();
      if (!chosen.length) return null;
      var match = pdpVariants.filter(function (v) {
        return v.options && v.options.length === chosen.length && v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      return match[0] || null;
    }

    function pdpUpdateVariant(v) {
      if (!v) return;
      if (idInput) {
        idInput.value = v.id;
        idInput.disabled = !v.available;
      }
      var priceNode = priceEl && priceEl.querySelector('.pdp-price__num');
      if (priceNode) priceNode.textContent = pdpMoney(v.price);
      var compareNode = priceEl && priceEl.querySelector('.pdp-price__compare');
      if (compareNode) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareNode.textContent = pdpMoney(v.compare_at_price);
          compareNode.hidden = false;
        } else {
          compareNode.hidden = true;
        }
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (buyLabel && buyBtn) {
        buyLabel.textContent = v.available
          ? (buyBtn.getAttribute('data-label-add') || buyLabel.textContent)
          : (buyBtn.getAttribute('data-label-sold-out') || buyLabel.textContent);
      }
      // Only the value node is rewritten, so the merchant's own SKU label stays.
      var skuValue = pdpSection.querySelector('[data-pdp-sku-value]');
      if (skuValue) skuValue.textContent = v.sku || '';
      var skuEl = pdpSection.querySelector('[data-pdp-sku]');
      if (skuEl) skuEl.hidden = !v.sku;
      var buyPrice = pdpSection.querySelector('[data-pdp-buy-price]');
      if (buyPrice) buyPrice.innerHTML = v.available ? '&nbsp;&middot; ' + pdpMoney(v.price) : '';

      // Keep the URL shareable and the back button honest.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Swap the main image to the variant's own media when it has one.
      if (v.featured_media && v.featured_media.preview_image) {
        var main = document.getElementById('pdp-main-image');
        if (main) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = v.featured_media.preview_image.src;
        }
      }
    }

    Array.prototype.forEach.call(pdpSection.querySelectorAll('[data-pdp-option]'), function (el) {
      el.addEventListener('change', function () {
        if (el.type === 'radio') {
          var group = el.closest('.pdp-variant-buttons');
          if (group) {
            Array.prototype.forEach.call(group.querySelectorAll('.pdp-variant-button'), function (l) {
              l.classList.remove('is-selected');
            });
            var label = el.closest('.pdp-variant-button');
            if (label) label.classList.add('is-selected');
          }
        }
        pdpUpdateVariant(pdpFindVariant());
      });
    });

    var pdpQty = pdpSection.querySelector('[data-pdp-qty]');
    if (pdpQty) {
      var pdpQtyInput = pdpQty.querySelector('input[type="number"]');
      Array.prototype.forEach.call(pdpQty.querySelectorAll('[data-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var val = (parseInt(pdpQtyInput.value, 10) || 1) + step;
          pdpQtyInput.value = Math.max(1, val);
        });
      });
    }

    // Gallery thumbnails. The handler was bound and firing all along; the swap
    // did nothing because Liquid's image_tag emits a `srcset` alongside `src`,
    // and a browser with a srcset picks its candidate from that list and
    // ignores src entirely. Clearing srcset (and sizes) is what actually makes
    // the new src take effect. Ken QC 2026-09-04, "thumbnail clicks don't
    // change the main image".
    var pdpMainImg = document.getElementById('pdp-main-image');
    Array.prototype.forEach.call(pdpSection.querySelectorAll('[data-pdp-thumb]'), function (thumb) {
      thumb.addEventListener('click', function () {
        if (pdpMainImg) {
          pdpMainImg.removeAttribute('srcset');
          pdpMainImg.removeAttribute('sizes');
          pdpMainImg.src = thumb.getAttribute('data-full');
          var full = thumb.getAttribute('data-alt');
          if (full !== null) pdpMainImg.alt = full;
        }
        Array.prototype.forEach.call(pdpSection.querySelectorAll('[data-pdp-thumb]'), function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // Share block. Native share sheet where the browser has one, clipboard
    // otherwise. Both paths need a secure context, so the button hides itself
    // when neither is available rather than looking broken.
    var share = pdpSection.querySelector('[data-pdp-share]');
    if (share) {
      var shareBtn = share.querySelector('[data-pdp-share-btn]');
      var shareStatus = share.querySelector('[data-pdp-share-status]');
      var canShare = !!navigator.share;
      var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);
      if (!canShare && !canCopy) {
        share.hidden = true;
      } else if (shareBtn) {
        shareBtn.addEventListener('click', function () {
          var url = share.getAttribute('data-share-url');
          var title = share.getAttribute('data-share-title');
          if (canShare) {
            navigator.share({ title: title, url: url }).catch(function () { /* dismissed */ });
          } else {
            navigator.clipboard.writeText(url).then(function () {
              if (shareStatus) {
                shareStatus.textContent = share.getAttribute('data-copied-text') || 'Link copied';
                setTimeout(function () { shareStatus.textContent = ''; }, 2500);
              }
            });
          }
        });
      }
    }
  }

  // PDP: fetch real Shopify product recommendations and swap them into the
  // related-products row if any come back (server-rendered fallback list of
  // other store products stays in place otherwise). See product-related.liquid.
  var pdpRelated = document.querySelector('[data-pdp-related]');
  if (pdpRelated && pdpRelated.getAttribute('data-url') && window.fetch) {
    fetch(pdpRelated.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pdp-related-inner]');
        var target = pdpRelated.querySelector('[data-pdp-related-inner]');
        if (fresh && target && fresh.children.length) {
          target.innerHTML = fresh.innerHTML;
          initReveals(pdpRelated);
        }
      })
      .catch(function () { /* keep the server-rendered fallback list */ });
  }

  // COLLECTION: filter form, filter drawer, column switcher and the two
  // JS pagination modes. Everything here is progressive enhancement over a
  // plain GET form -- with JS off, Apply still submits, sort still submits on
  // the button, and Load more / Infinite scroll degrade to a link to page 2.
  var collectionSection = document.querySelector('[data-collection-grid]');
  if (collectionSection) {
    // Submitting the form by hand rather than letting the browser do it: empty
    // fields must be stripped, or the URL fills with `filter.v.price.gte=` style
    // noise that Shopify then treats as a real (empty) filter.
    function collectionSubmit(url) {
      if (!window.fetch || !window.history || !window.history.pushState) {
        window.location.href = url;
        return;
      }
      collectionSection.classList.add('is-loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-grid]');
          if (!fresh) { window.location.href = url; return; }
          collectionSection.innerHTML = fresh.innerHTML;
          window.history.pushState({}, '', url);
          bindCollection();
          initReveals(collectionSection);
        })
        .catch(function () { window.location.href = url; })
        .then(function () { collectionSection.classList.remove('is-loading'); });
    }

    function collectionFormUrl(form) {
      var base = window.location.pathname;
      var params = [];
      var seenSort = false;
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.disabled) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '') return;
        // Two sort selects (mobile bar, desktop toolbar) are bound to this
        // form; they are kept in sync on change, so send sort_by once.
        if (el.name === 'sort_by') {
          if (seenSort) return;
          seenSort = true;
        }
        params.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
      });
      return params.length ? base + '?' + params.join('&') : base;
    }

    // The drawer closes on every re-render (the section's innerHTML is
    // replaced), so while it is open the checkboxes must NOT auto-apply or
    // the panel would slam shut on the first tap. Apply submits and closes.
    var drawerIsOpen = false;
    var backdrop = null;

    function removeBackdrop() {
      document.body.classList.remove('filters-open');
      if (backdrop) { backdrop.remove(); backdrop = null; }
      drawerIsOpen = false;
    }

    function bindCollection() {
      var form = collectionSection.querySelector('[data-collection-filter-form]');
      var sorts = collectionSection.querySelectorAll('[data-collection-sort]');
      var drawer = collectionSection.querySelector('[data-filter-drawer]');
      var openBtn = collectionSection.querySelector('[data-filter-drawer-open]');

      // A submit from inside the drawer closes it; the re-render below
      // rebuilds the panel in its closed state anyway.
      function submitForm() {
        removeBackdrop();
        collectionSubmit(collectionFormUrl(form));
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          submitForm();
        });
        // Checkbox filters apply immediately in the embedded desktop column;
        // the Apply button stays for the price inputs and for keyboard users
        // who never fire a change event. Inside an open drawer they wait for
        // Apply (see drawerIsOpen).
        Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"]'), function (cb) {
          cb.addEventListener('change', function () {
            if (drawerIsOpen) return;
            submitForm();
          });
        });
      }

      Array.prototype.forEach.call(sorts, function (sort) {
        sort.addEventListener('change', function () {
          Array.prototype.forEach.call(sorts, function (other) { other.value = sort.value; });
          // The sort select is bound to the filter form with form=, so it is in
          // form.elements even though it sits in the toolbar. With no filters
          // configured there is no form at all, so fall back to the sort alone.
          if (form) {
            submitForm();
          } else {
            collectionSubmit(window.location.pathname + '?sort_by=' + encodeURIComponent(sort.value));
          }
        });
      });

      // Active-filter chips and the Clear links: plain hrefs from Shopify
      // (url_to_remove / collection.url), fetched in place like the form.
      Array.prototype.forEach.call(collectionSection.querySelectorAll('[data-collection-chip]'), function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          removeBackdrop();
          collectionSubmit(chip.getAttribute('href'));
        });
      });

      // Filter drawer. Every Filter style is a drawer on mobile and Drawer
      // mode is one on desktop too; CSS decides whether .is-open matters at
      // the current width, this only toggles it.
      if (drawer && openBtn) {
        function closeDrawer() {
          drawer.classList.remove('is-open');
          openBtn.setAttribute('aria-expanded', 'false');
          removeBackdrop();
          openBtn.focus();
        }
        openBtn.addEventListener('click', function () {
          drawer.classList.add('is-open');
          drawerIsOpen = true;
          openBtn.setAttribute('aria-expanded', 'true');
          document.body.classList.add('filters-open');
          backdrop = document.createElement('div');
          backdrop.className = 'collection-filters-backdrop';
          backdrop.addEventListener('click', closeDrawer);
          document.body.appendChild(backdrop);
          var closeBtn = drawer.querySelector('[data-filter-drawer-close]');
          if (closeBtn) closeBtn.focus();
        });
        var closeBtn = drawer.querySelector('[data-filter-drawer-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
        });
      }

      // Column switcher. Writes --cg-cols on the grid itself, which beats the
      // inherited per-section value from rgm-section-style.
      var grid = collectionSection.querySelector('[data-collection-products]');
      Array.prototype.forEach.call(collectionSection.querySelectorAll('[data-set-columns]'), function (btn) {
        btn.addEventListener('click', function () {
          if (!grid) return;
          grid.style.setProperty('--cg-cols', btn.getAttribute('data-set-columns'));
          Array.prototype.forEach.call(collectionSection.querySelectorAll('[data-set-columns]'), function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
      });

      bindLoadMore();
    }

    // Load more / Infinite scroll. Both append the next page's cards into the
    // existing grid and move the trigger to the page after that; when there is
    // no next page the trigger is removed. Infinite scroll is the same
    // mechanism with an IntersectionObserver pulling the trigger.
    function bindLoadMore() {
      var trigger = collectionSection.querySelector('[data-collection-load-more]');
      if (!trigger || !window.fetch) return;

      var loading = false;
      function loadNext() {
        if (loading) return;
        loading = true;
        var url = trigger.getAttribute('href');
        trigger.classList.add('is-loading');
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshGrid = doc.querySelector('[data-collection-products]');
            var grid = collectionSection.querySelector('[data-collection-products]');
            if (freshGrid && grid) {
              var added = [];
              Array.prototype.forEach.call(freshGrid.children, function (card) {
                added.push(card.cloneNode(true));
              });
              added.forEach(function (card) { grid.appendChild(card); });
              initReveals(grid);
            }
            var freshTrigger = doc.querySelector('[data-collection-load-more]');
            if (freshTrigger) {
              trigger.setAttribute('href', freshTrigger.getAttribute('href'));
            } else {
              var wrap = trigger.parentNode;
              trigger.remove();
              if (observer) observer.disconnect();
              if (wrap && !wrap.children.length) wrap.remove();
            }
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, '', url);
            }
          })
          .catch(function () { window.location.href = url; })
          .then(function () {
            loading = false;
            if (trigger) trigger.classList.remove('is-loading');
          });
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        loadNext();
      });

      var observer = null;
      if (trigger.hasAttribute('data-collection-infinite') && window.IntersectionObserver) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
        }, { rootMargin: '400px' });
        observer.observe(trigger);
      }
    }

    bindCollection();
  }
})();
